import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { ViveroGrupoEspecie } from './entity-viveros-grupo-especie.model';
import { environment } from 'projects/registro-personas-empresas/src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ViverosGrupoEspecieService {
  url: string;
  endpoint = 'viveros';

  constructor(private http: HttpClient) {}

  getViverosGrupoEspecie(): Observable<ViveroGrupoEspecie[]> {
    return this.http.get<ViveroGrupoEspecie[]>(`${this.url}/${this.endpoint}/`);
  }

  addViveroGrupoEspecie(
    viverosGrupoEspecie: ViveroGrupoEspecie[]
  ): Observable<ViveroGrupoEspecie[]> {
    return this.http.post<ViveroGrupoEspecie[]>(
      `${this.url}/${this.endpoint}/`,
      {
        viveros: viverosGrupoEspecie
      }
    );
  }

  deleteVivero(vivero: ViveroGrupoEspecie): Observable<ViveroGrupoEspecie> {
    return this.http.delete<ViveroGrupoEspecie>(
      `${environment.apiUrl}/${this.endpoint}/${vivero.id}/`
    );
  }

  /*
  changeActividadGrupoEspecie(p: ActividadGrupoEspecie): Observable<ActividadGrupoEspecie> {
    return this.http.patch<ActividadGrupoEspecie>(`${this.url}/${this.endpoint}/${p.id}`, {
      actividadGrupoEspecie: p,
      token: this.token
    });
  }

  deleteActividadGrupoEspecie(p: ActividadGrupoEspecie): Observable<ActividadGrupoEspecie> {
    return this.http.delete<ActividadGrupoEspecie>(`${this.url}/${this.endpoint}/${p.id}`, {
      params: { token: this.token }
    });
  }
  */
}
